import React from 'react';
import { useAgents } from '../../hooks/useAgents';

function ChatSidebar({ conversations, activeConversationId, onSelect, onNew, onDelete }) {
  const { getAgent } = useAgents();

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Agora';
    if (diffMins < 60) return `${diffMins}min`;
    if (diffHours < 24) return `${diffHours}h`;
    if (diffDays < 7) return `${diffDays}d`;
    return date.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
  };

  return (
    <aside className="chat-sidebar">
      <div className="chat-sidebar-header">
        <button className="btn btn-primary" onClick={onNew}>
          + Nova Conversa
        </button>
      </div>
      <div className="chat-sidebar-list">
        {conversations.length === 0 ? (
          <div className="chat-sidebar-empty">
            Nenhuma conversa ainda.<br />Clique em "Nova Conversa" para comecar.
          </div>
        ) : (
          conversations.map(conv => {
            const agent = getAgent(conv.agent_id);
            return (
              <button
                key={conv.id}
                className={`chat-sidebar-item ${conv.id === activeConversationId ? 'active' : ''}`}
                onClick={() => onSelect(conv.id)}
              >
                <div className="chat-sidebar-item-title">
                  {agent?.icon} {conv.title}
                </div>
                <div className="chat-sidebar-item-meta">
                  <span>{agent?.name || conv.agent_id}</span>
                  {conv.client_id && <span>• {conv.client_id}</span>}
                  <span>• {formatDate(conv.updated_at)}</span>
                  <button
                    className="chat-sidebar-item-delete"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete(conv.id);
                    }}
                    title="Excluir conversa"
                  >
                    &#x2715;
                  </button>
                </div>
              </button>
            );
          })
        )}
      </div>
    </aside>
  );
}

export default ChatSidebar;
